import { render, staticRenderFns } from "./LanguageManagement.vue?vue&type=template&id=6ef2a25a&scoped=true"
import script from "./LanguageManagement.vue?vue&type=script&lang=js"
export * from "./LanguageManagement.vue?vue&type=script&lang=js"
import style0 from "./LanguageManagement.vue?vue&type=style&index=0&id=6ef2a25a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef2a25a",
  null
  
)

export default component.exports